// import Mapbox from 'components/base/MapBox';
import { Col, Row } from 'react-bootstrap';
import HelpCenter from '../default/address/HelpCenter';
import QueryForm from '../default/address/QueryForm';

const AddressSection = () => {
  return (
    <section id="support" className="pb-10 pb-xl-14">
      <div className="container-small px-lg-7 px-xxl-3">
        <div className="text-center mb-4">
          <h1 className="text-gradient-info mt-8 mb-4">Let's Connect</h1>
          <h2 className="mb-8">Let us know how we can Help!</h2>
        </div>
        <Row className="g-5 g-lg-5 mb-0">
          <Col
            xs={12}
            md={6}
            className="mb-5 mb-md-0 text-center text-md-start"
          >
            <HelpCenter />
          </Col>
          <Col xs={12} md={6} className="text-center text-md-start">
            <QueryForm />
          </Col>
        </Row>
        {/*<div className="mb-15">
          <Mapbox
            className="rounded-4"
            style={{ height: 380 }}
            options={{
              center: [-74.0020158, 40.7228022],
              zoom: 14,
              scrollZoom: false
            }}
          />
        </div>*/}
      </div>
    </section>
  );
};

export default AddressSection;
